import React from 'react';

import styled from 'styled-components';

import {
  deleteActionPlanComment,
  getActionPlanComments,
  postActionPlanComment,
  updateActionPlanComment,
} from 'apis/ActionPlansAPI';
import CommentsSection from 'components/CommunityInfo/general/comments/CommentsSection';
import { useAppSelector } from 'store/hook';

const ACTION_PLAN_COMMENTS_QUERY_KEY_SCOPE = 'action-plan';
const ACTION_PLAN_COMMENTS_TEST_ID_PREFIX = 'action-plan-comments';

const Container = styled.div`
  background: var(--background-gray-light);
  border: 1px solid var(--line-gray);
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 0 20px 20px;
`;

type Props = {
  actionPlanId: number;
};

const ActionPlanComments = ({ actionPlanId }: Props) => {
  const { currentUser } = useAppSelector((state) => state.auth);

  return (
    <Container data-test-id="action-plan-details-comments">
      <CommentsSection
        entityId={actionPlanId}
        title="Team Discussion"
        queryKeyScope={ACTION_PLAN_COMMENTS_QUERY_KEY_SCOPE}
        currentUserId={currentUser?.user_id}
        currentUserAvatarUrl={currentUser?.avatar}
        currentUserName={currentUser?.FullName}
        dataTestIdPrefix={ACTION_PLAN_COMMENTS_TEST_ID_PREFIX}
        getComments={getActionPlanComments}
        postComment={postActionPlanComment}
        updateComment={updateActionPlanComment}
        deleteComment={deleteActionPlanComment}
      />
    </Container>
  );
};

export default ActionPlanComments;
